// Information architecture for the public website (header mega-menu + footer).
// Labels are bilingual: { en, hi }.
export const SITE_NAV = [
    {
        key: 'solutions',
        label: { en: 'Solar Solutions', hi: 'सोलर समाधान' },
        columns: [
            {
                title: { en: 'For Homes', hi: 'घरों के लिए' },
                items: [
                    { to: '/residential-solar', label: { en: 'Residential Solar', hi: 'घरेलू सोलर' }, desc: { en: '1–10 kW rooftop with subsidy', hi: '1–10 kW रूफटॉप, सब्सिडी सहित' } },
                    { to: '/residential-solar/on-grid', label: { en: 'On-Grid System', hi: 'ऑन-ग्रिड सिस्टम' }, desc: { en: 'Net-metering, lowest cost', hi: 'Net-metering, सबसे कम लागत' } },
                    { to: '/residential-solar/hybrid', label: { en: 'Hybrid System', hi: 'हाइब्रिड सिस्टम' }, desc: { en: 'Battery backup for power cuts', hi: 'पावर-कट के लिए बैटरी बैकअप' } },
                    { to: '/residential-solar/off-grid', label: { en: 'Off-Grid System', hi: 'ऑफ-ग्रिड सिस्टम' }, desc: { en: 'For sites without grid', hi: 'जहाँ ग्रिड नहीं है' } },
                ],
            },
            {
                title: { en: 'For Business', hi: 'व्यवसाय के लिए' },
                items: [
                    { to: '/housing-society-solar', label: { en: 'Housing Society / RWA', hi: 'हाउसिंग सोसाइटी / RWA' }, desc: { en: 'Common-area solar, ₹18,000/kW subsidy', hi: 'Common-area सोलर, ₹18,000/kW सब्सिडी' } },
                    { to: '/commercial-solar', label: { en: 'Commercial & Industrial', hi: 'कमर्शियल और इंडस्ट्रियल' }, desc: { en: '10 kW – 5 MW, CAPEX / OPEX', hi: '10 kW – 5 MW, CAPEX / OPEX' } },
                ],
            },
        ],
    },
    {
        key: 'products',
        label: { en: 'Products', hi: 'उत्पाद' },
        columns: [
            {
                title: { en: 'Components', hi: 'कंपोनेंट' },
                items: [
                    { to: '/products/solar-panels', label: { en: 'Solar Panels', hi: 'सोलर पैनल' }, desc: { en: 'DCR Mono-PERC / TOPCon', hi: 'DCR Mono-PERC / TOPCon' } },
                    { to: '/products/inverters', label: { en: 'Inverters', hi: 'इन्वर्टर' }, desc: { en: 'On-grid & hybrid', hi: 'ऑन-ग्रिड और हाइब्रिड' } },
                    { to: '/products/batteries', label: { en: 'Batteries', hi: 'बैटरी' }, desc: { en: 'Lithium LFP & tubular', hi: 'Lithium LFP और tubular' } },
                    { to: '/products/mounting-structures', label: { en: 'Mounting Structures', hi: 'माउंटिंग स्ट्रक्चर' }, desc: { en: 'HDG, 150 km/h rated', hi: 'HDG, 150 km/h' } },
                    { to: '/products', label: { en: 'All Products →', hi: 'सभी उत्पाद →' } },
                ],
            },
            {
                title: { en: 'Pricing', hi: 'कीमत' },
                items: [
                    { to: '/pricing', label: { en: 'Packages & Prices', hi: 'पैकेज और कीमतें' }, desc: { en: '1 kW – 10 kW with subsidy breakdown', hi: '1 kW – 10 kW, सब्सिडी breakdown सहित' } },
                    { to: '/solar-calculator', label: { en: 'Savings Calculator', hi: 'बचत कैलकुलेटर' }, desc: { en: 'Bill → system size → EMI', hi: 'बिल → सिस्टम साइज़ → EMI' } },
                    { to: '/financing', label: { en: 'Financing & Loans', hi: 'फाइनेंसिंग और लोन' }, desc: { en: '₹0 down, 7% scheme loan', hi: '₹0 down, 7% योजना लोन' } },
                ],
            },
        ],
    },
    {
        key: 'subsidy',
        label: { en: 'Subsidy', hi: 'सब्सिडी' },
        to: '/pm-surya-ghar-subsidy',
    },
    {
        key: 'resources',
        label: { en: 'Resources', hi: 'जानकारी' },
        columns: [
            {
                title: { en: 'Learn', hi: 'सीखें' },
                items: [
                    { to: '/how-it-works', label: { en: 'How It Works', hi: 'कैसे काम करता है' }, desc: { en: '6 steps from enquiry to ₹0 bill', hi: 'पूछताछ से ₹0 बिल तक 6 कदम' } },
                    { to: '/warranty-amc', label: { en: 'Warranty & AMC', hi: 'वारंटी और AMC' }, desc: { en: '25-yr panels, 5-yr free AMC', hi: '25 साल पैनल, 5 साल फ्री AMC' } },
                    { to: '/customer-stories', label: { en: 'Customer Stories', hi: 'ग्राहकों की कहानियाँ' }, desc: { en: 'Photos, bills & video testimonials', hi: 'फोटो, बिल और वीडियो testimonials' } },
                    { to: '/blog', label: { en: 'Blog / Knowledge Hub', hi: 'ब्लॉग / नॉलेज हब' }, desc: { en: 'Guides & subsidy updates', hi: 'गाइड और सब्सिडी अपडेट' } },
                    { to: '/faq', label: { en: 'FAQ', hi: 'सवाल-जवाब' } },
                ],
            },
            {
                title: { en: 'Company', hi: 'कंपनी' },
                items: [
                    { to: '/why-uppower', label: { en: 'Why UPPower', hi: 'UPPower क्यों' } },
                    { to: '/about', label: { en: 'About Us', hi: 'हमारे बारे में' } },
                    { to: '/service-areas', label: { en: 'Service Areas', hi: 'सेवा क्षेत्र' }, desc: { en: '40+ UP districts', hi: '40+ UP ज़िले' } },
                    { to: '/careers', label: { en: 'Careers', hi: 'करियर' } },
                    { to: '/contact', label: { en: 'Contact', hi: 'संपर्क' } },
                ],
            },
        ],
    },
];

export const FOOTER_GROUPS = [
    {
        title: { en: 'Solutions', hi: 'समाधान' },
        links: [
            { to: '/residential-solar', label: { en: 'Residential Solar', hi: 'घरेलू सोलर' } },
            { to: '/residential-solar/on-grid', label: { en: 'On-Grid', hi: 'ऑन-ग्रिड' } },
            { to: '/residential-solar/hybrid', label: { en: 'Hybrid', hi: 'हाइब्रिड' } },
            { to: '/residential-solar/off-grid', label: { en: 'Off-Grid', hi: 'ऑफ-ग्रिड' } },
            { to: '/housing-society-solar', label: { en: 'Housing Society', hi: 'हाउसिंग सोसाइटी' } },
            { to: '/commercial-solar', label: { en: 'Commercial & Industrial', hi: 'कमर्शियल और इंडस्ट्रियल' } },
        ],
    },
    {
        title: { en: 'Products & Pricing', hi: 'उत्पाद और कीमत' },
        links: [
            { to: '/products/solar-panels', label: { en: 'Solar Panels', hi: 'सोलर पैनल' } },
            { to: '/products/inverters', label: { en: 'Inverters', hi: 'इन्वर्टर' } },
            { to: '/products/batteries', label: { en: 'Batteries', hi: 'बैटरी' } },
            { to: '/products/mounting-structures', label: { en: 'Structures', hi: 'स्ट्रक्चर' } },
            { to: '/pricing', label: { en: 'Packages & Prices', hi: 'पैकेज और कीमतें' } },
            { to: '/solar-calculator', label: { en: 'Savings Calculator', hi: 'बचत कैलकुलेटर' } },
        ],
    },
    {
        title: { en: 'Resources', hi: 'जानकारी' },
        links: [
            { to: '/pm-surya-ghar-subsidy', label: { en: 'PM Surya Ghar Subsidy', hi: 'PM सूर्य घर सब्सिडी' } },
            { to: '/financing', label: { en: 'Financing & Loans', hi: 'फाइनेंसिंग और लोन' } },
            { to: '/how-it-works', label: { en: 'How It Works', hi: 'कैसे काम करता है' } },
            { to: '/warranty-amc', label: { en: 'Warranty & AMC', hi: 'वारंटी और AMC' } },
            { to: '/customer-stories', label: { en: 'Customer Stories', hi: 'ग्राहकों की कहानियाँ' } },
            { to: '/blog', label: { en: 'Blog', hi: 'ब्लॉग' } },
            { to: '/faq', label: { en: 'FAQ', hi: 'सवाल-जवाब' } },
        ],
    },
    {
        title: { en: 'Company', hi: 'कंपनी' },
        links: [
            { to: '/why-uppower', label: { en: 'Why UPPower', hi: 'UPPower क्यों' } },
            { to: '/about', label: { en: 'About Us', hi: 'हमारे बारे में' } },
            { to: '/service-areas', label: { en: 'Service Areas', hi: 'सेवा क्षेत्र' } },
            { to: '/careers', label: { en: 'Careers', hi: 'करियर' } },
            { to: '/contact', label: { en: 'Contact Us', hi: 'संपर्क करें' } },
            { to: '/privacy', label: { en: 'Privacy Policy', hi: 'गोपनीयता नीति' } },
        ],
    },
];
